import { RouterModule, Routes } from "@angular/router";

const APP_ROUTES: Routes = [
    { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
    { path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule) },
    { path: '**', redirectTo: 'auth/login' }
];

export const AppRoutes = RouterModule.forRoot(APP_ROUTES, { useHash: true });